import { RiTestTubeLine } from "@onemind-services-llc/react-icons-ng/ri";
import {
  MdOutlineCloudDone,
  MdOutlineIntegrationInstructions,
  MdOutlineSupportAgent,
} from "@onemind-services-llc/react-icons-ng/md";
import { SimpleList } from "@/components/list";

export const ONEMIND_POCAAS_CONSTANTS = {
  title: "Why Choose OneMind Services POCaaS?",
  desc: "At OneMind Services, we offer an industry-leading POC-as-a-Service (POCaaS) solution that helps businesses validate technologies before full-scale implementation.",
  list: [
    {
      icon: RiTestTubeLine,
      title: "Comprehensive & Tailored Testing",
      content: (
        <SimpleList
          points={[
            "Comprehensive testing in a fully replicated cloud-based environment for accurate performance assessment.",
            "Tailored POC frameworks to customize testing scenarios for specific business needs.",
          ]}
        />
      ),
    },
    {
      icon: MdOutlineCloudDone,
      title: "Cost-Efficient & Seamless Deployment",
      content: (
        <SimpleList
          points={[
            "Zero hardware investment with cloud-managed infrastructure, reducing costs.",
            "Smooth transition from POC to full implementation without disruptions.",
          ]}
        />
      ),
    },
    {
      icon: MdOutlineSupportAgent,
      title: "Expert Guidance & Optimization",
      content: (
        <SimpleList
          points={[
            "Access to expert insights for effective POC execution and strategic decision-making.",
            "Support for fine-tuning solutions to align with business objectives.",
          ]}
        />
      ),
    },
    {
      icon: MdOutlineIntegrationInstructions,
      title: "Scalable & Flexible Solutions",
      content: (
        <SimpleList
          points={[
            "Elastic resource allocation to adapt to varying workloads.",
            "Integration-ready architecture for future expansion.",
          ]}
        />
      ),
    },
  ],
  conclusion:
    "With OneMind Services POCaaS, you can confidently explore new innovations, streamline integrations, and make data-backed technology decisions—all within a secure, cloud-based environment.",
};
